import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" actions: intents the UI dispatches for the saga to act on. Kept out of
 * the slice's reducers: they trigger the paginated fetch (a side effect), not the
 * state transitions (the saga owns the resulting `load*` / cursor transitions).
 */

/** Load the current page (dispatched by the page on mount). */
export const schoolsRequested = createAction('schools/schoolsRequested');

/** Navigate to a 0-indexed page. */
export const pageChanged = createAction<number>('schools/pageChanged');

/** Change the page size (resets to the first page). */
export const pageSizeChanged = createAction<number>('schools/pageSizeChanged');
